import { LoginScreen, LogoutScreen } from '@/admin/screens/auth';
import {
  AdminMainScreen,

  /* Colors */
  AdminColorsScreen,
  AdminColorsNewScreen,
  AdminColorsEditScreen,

  /* Fabrics */
  AdminFabricsScreen,
  AdminFabricsEditScreen,

  /* Interlinings */
  AdminInterliningsScreen,
  AdminInterliningsNewScreen,
  AdminInterliningsEditScreen,

  /* Initials */
  AdminInitialsEditScreen,

  /* Formulas */
  AdminFormulasScreen,
  AdminFormulasNewScreen,
  AdminFormulasEditScreen,

  /* Embroideries */
  AdminStandardEmbroideriesEditScreen,
  AdminStandardEmbroideriesNewScreen,
  AdminEmbroiderySettingsScreen,

  /* Stitches */
  AdminStitchesScreen,
  AdminStitchesEditScreen,

  /* Product selectors */
  AdminProductSelectorsScreen,
  AdminProductSelectorsNewScreen,
  AdminProductSelectorsEditScreen,

  /* Product templates */
  AdminProductTemplatesScreen,
  AdminProductTemplatesNewScreen,
  AdminProductTemplatesEditScreen,

  /* Product templates */
  AdminProductAttributesScreen,

  /* Products */
  AdminProductsScreen,
  AdminProductsEditScreen,

  /* Product categories */
  AdminProductCategoriesScreen,
  AdminProductCategoriesEditScreen,

  /* Embroidery categories */
  AdminEmbroideryCategoriesScreen,
  AdminEmbroideryCategoriesNewScreen,
  AdminEmbroideryCategoriesEditScreen,

  /* Product categories */
  AdminPredefinedProductCategoriesScreen,
  AdminPredefinedProductCategoriesEditScreen,

  /* Customers */
  AdminCustomersScreen,
  AdminCustomersEditScreen,

  /* Quotes */
  AdminQuotesScreen,
  AdminQuotesAllScreen,
  AdminQuotesEditScreen,

  /* Orders */
  AdminOrdersScreen,
  AdminOrdersEditScreen,

  /* Workshop orders */
  AdminWorkshopOrdersScreen,
  AdminWorkshopOrdersEditScreen,

  // Workshop stock orders
  AdminWorkshopStockOrdersScreen,
  AdminWorkshopStockOrdersEditScreen,

  /* Deliveries */
  AdminDeliveriesScreen,
  AdminDeliveriesEditScreen,

  /* Invoices */
  AdminInvoicesScreen,

  /*  */
  AdminEmbroideredStripsScreen,
  AdminEmbroideredStripsEditScreen,

  /* Predefined products */
  AdminPredefinedProductsScreen,
  AdminPredefinedProductsEditScreen,
  AdminAnalyticsDownloadsScreen,
  AdminWebHomeSettingsScreen,

  /* Stock */
  AdminStockLinesScreen,
  AdminStockLinesEditScreen,
  AdminCashEditScreen,

  // Commissions
  AdminCommissionsScreen,

  // Vouchers
  AdminVouchersScreen,

  // Workshop tasks
  AdminWorkshopTasksScreen,
  AdminWorkshopTasksEditScreen,

  // Generic product attributes
  AdminGenericProductAttributesScreen,
  AdminGenericProductAttributesEditScreen,
} from '@/admin/screens';

export default [
  {
    name: 'AdminMainScreen',
    path: '/',
    component: AdminMainScreen,
    meta: {
      authRequired: true,
    },
  },
  {
    path: 'login',
    name: 'LoginScreen',
    component: LoginScreen,
    meta: {
      authRequired: false,
    },
  },
  // {
  //   path: 'categories',
  //   name: 'AdminCategoriesScreen',
  //   component: AdminCategoriesScreen,
  //   meta: {
  //     authRequired: true,
  //     loadOverlay: true,
  //   },
  // },

  /* Colors */
  {
    path: 'colors',
    name: 'AdminColorsScreen',
    component: AdminColorsScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'colors/new',
    name: 'AdminColorsNewScreen',
    component: AdminColorsNewScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  {
    path: 'colors/:id',
    props: true,
    name: 'AdminColorsEditScreen',
    component: AdminColorsEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Fabric */
  {
    path: 'fabrics',
    name: 'AdminFabricsScreen',
    component: AdminFabricsScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'fabrics/:id',
    props: true,
    name: 'AdminFabricsEditScreen',
    component: AdminFabricsEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Interlining */
  {
    path: 'interlinings',
    name: 'AdminInterliningsScreen',
    component: AdminInterliningsScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'interlinings/new',
    name: 'AdminInterliningsNewScreen',
    component: AdminInterliningsNewScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  {
    path: 'interlinings/:id',
    props: true,
    name: 'AdminInterliningsEditScreen',
    component: AdminInterliningsEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Initials */

  {
    path: 'initials',
    name: 'AdminInitialsEditScreen',
    component: AdminInitialsEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },

  /* Formulas */

  {
    path: 'formulas',
    name: 'AdminFormulasScreen',
    component: AdminFormulasScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'formulas/new',
    name: 'AdminFormulasNewScreen',
    component: AdminFormulasNewScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  {
    path: 'formulas/:id',
    props: true,
    name: 'AdminFormulasEditScreen',
    component: AdminFormulasEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Embroideries */

  {
    path: 'embroideries',
    name: 'AdminEmbroiderySettingsScreen',
    component: AdminEmbroiderySettingsScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  {
    path: 'embroideries/standard/new',
    name: 'AdminStandardEmbroideriesNewScreen',
    component: AdminStandardEmbroideriesNewScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  {
    path: 'embroideries/standard/:id',
    props: true,
    name: 'AdminStandardEmbroideriesEditScreen',
    component: AdminStandardEmbroideriesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Stitches */
  {
    path: 'stitches',
    name: 'AdminStitchesScreen',
    component: AdminStitchesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },

  {
    path: 'stitches/:id',
    props: true,
    name: 'AdminStitchesEditScreen',
    component: AdminStitchesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Product selectors */
  {
    path: 'productselectors',
    name: 'AdminProductSelectorsScreen',
    component: AdminProductSelectorsScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'productselectors/new',
    name: 'AdminProductSelectorsNewScreen',
    component: AdminProductSelectorsNewScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },
  {
    path: 'productselectors/:reference',
    props: true,
    name: 'AdminProductSelectorsEditScreen',
    component: AdminProductSelectorsEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Product templates */
  {
    path: 'producttemplates',
    name: 'AdminProductTemplatesScreen',
    component: AdminProductTemplatesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'producttemplates/new',
    name: 'AdminProductTemplatesNewScreen',
    component: AdminProductTemplatesNewScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },
  {
    path: 'producttemplates/:reference',
    props: true,
    name: 'AdminProductTemplatesEditScreen',
    component: AdminProductTemplatesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Product attributes */
  {
    path: 'productattributes',
    name: 'AdminProductAttributesScreen',
    component: AdminProductAttributesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },

  /* Offline products */
  {
    path: 'products',
    name: 'AdminProductsScreen',
    component: AdminProductsScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'products/:id',
    props: true,
    name: 'AdminProductsEditScreen',
    component: AdminProductsEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Predefined products */
  {
    path: 'predefinedproducts',
    name: 'AdminPredefinedProductsScreen',
    component: AdminPredefinedProductsScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'predefinedproducts/:id',
    props: true,
    name: 'AdminPredefinedProductsEditScreen',
    component: AdminPredefinedProductsEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Product categories */
  {
    path: 'productcategories',
    name: 'AdminProductCategoriesScreen',
    component: AdminProductCategoriesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },

  {
    path: 'productcategories/:id',
    props: true,
    name: 'AdminProductCategoriesEditScreen',
    component: AdminProductCategoriesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Embroidery categories */
  {
    path: 'embroiderycategories',
    name: 'AdminEmbroideryCategoriesScreen',
    component: AdminEmbroideryCategoriesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'embroiderycategories/new',
    name: 'AdminEmbroideryCategoriesNewScreen',
    component: AdminEmbroideryCategoriesNewScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },
  {
    path: 'embroiderycategories/:id',
    props: true,
    name: 'AdminEmbroideryCategoriesEditScreen',
    component: AdminEmbroideryCategoriesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Predefined product categories */
  {
    path: 'predefinedproductcategories',
    name: 'AdminPredefinedProductCategoriesScreen',
    component: AdminPredefinedProductCategoriesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'predefinedproductcategories/:id',
    props: true,
    name: 'AdminPredefinedProductCategoriesEditScreen',
    component: AdminPredefinedProductCategoriesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Customers */
  {
    path: 'customers',
    name: 'AdminCustomersScreen',
    component: AdminCustomersScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'customers/:id',
    props: true,
    name: 'AdminCustomersEditScreen',
    component: AdminCustomersEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Quotes */
  {
    path: 'quotes/location/:location',
    name: 'AdminQuotesScreen',
    component: AdminQuotesScreen,
    props: true,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'quotes/all',
    name: 'AdminQuotesAllScreen',
    component: AdminQuotesAllScreen,
    props: true,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'quotes/:id',
    props: true,
    name: 'AdminQuotesEditScreen',
    component: AdminQuotesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Orders */
  {
    path: 'orders/location/:location',
    name: 'AdminOrdersScreen',
    component: AdminOrdersScreen,
    props: true,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'orders/:id',
    props: true,
    name: 'AdminOrdersEditScreen',
    component: AdminOrdersEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Workshop Orders */
  {
    path: 'workshop-orders',
    name: 'AdminWorkshopOrdersScreen',
    component: AdminWorkshopOrdersScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'workshop-orders/:id',
    props: true,
    name: 'AdminWorkshopOrdersEditScreen',
    component: AdminWorkshopOrdersEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },
  {
    path: 'workshop-stock-orders',
    name: 'AdminWorkshopStockOrdersScreen',
    component: AdminWorkshopStockOrdersScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },

  {
    path: 'workshop-stock-orders/:id',
    props: true,
    name: 'AdminWorkshopStockOrdersEditScreen',
    component: AdminWorkshopStockOrdersEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Deliveries */
  {
    path: 'deliveries',
    name: 'AdminDeliveriesScreen',
    component: AdminDeliveriesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'deliveries/:id',
    props: true,
    name: 'AdminDeliveriesEditScreen',
    component: AdminDeliveriesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Invoices */
  {
    path: 'invoices',
    name: 'AdminInvoicesScreen',
    component: AdminInvoicesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'invoices/:customerid',
    props: true,
    name: 'AdminInvoicesCustomerScreen',
    component: AdminInvoicesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },

  /* Embroided Strips */
  {
    path: 'embroideredstrips',
    name: 'AdminEmbroideredStripsScreen',
    component: AdminEmbroideredStripsScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'embroideredstrips/:id',
    props: true,
    name: 'AdminEmbroideredStripsEditScreen',
    component: AdminEmbroideredStripsEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  {
    path: 'logout',
    name: 'LogoutScreen',
    component: LogoutScreen,
    meta: {
      authRequired: false,
    },
  },
  {
    path: 'analytics-downloads',
    name: 'AdminAnalyticsDownloadsScreen',
    component: AdminAnalyticsDownloadsScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  //  Web
  {
    path: 'web-home-settings',
    name: 'AdminWebHomeSettingsScreen',
    component: AdminWebHomeSettingsScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  // Stock
  {
    path: 'stock-lines/location/:location',
    name: 'AdminStockLinesScreen',
    component: AdminStockLinesScreen,
    props: true,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },

  // Vouchers
  {
    path: 'vouchers/location/:location',
    name: 'AdminVouchersScreen',
    component: AdminVouchersScreen,
    props: true,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'stock-lines/:id',
    props: true,
    name: 'AdminStockLinesEditScreen',
    component: AdminStockLinesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },
  {
    path: 'cash/location/:location',
    props: true,
    name: 'AdminCashEditScreen',
    component: AdminCashEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },
  {
    path: 'cash/location/:location/commissions/:employee',
    props: true,
    name: 'AdminCommissionsScreen',
    component: AdminCommissionsScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  // Workshop tasks
  {
    path: 'workshop-tasks',
    name: 'AdminWorkshopTasksScreen',
    component: AdminWorkshopTasksScreen,
    props: true,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },
  {
    path: 'workshop-tasks/:id',
    props: true,
    name: 'AdminWorkshopTasksEditScreen',
    component: AdminWorkshopTasksEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },

  /* Generic product attributes */
  {
    path: 'genericproductattributes',
    name: 'AdminGenericProductAttributesScreen',
    component: AdminGenericProductAttributesScreen,
    meta: {
      authRequired: true,
      loadOverlay: true,
    },
  },

  {
    path: 'genericproductattributes/:reference',
    props: true,
    name: 'AdminGenericProductAttributesEditScreen',
    component: AdminGenericProductAttributesEditScreen,
    meta: {
      authRequired: true,
      loadOverlay: false,
    },
  },
];
